import React, { useState, useContext } from "react";
import { Container, Tabs, Tab } from "react-bootstrap";
import { AuthContext } from "../context/AuthContext";
import WorkerRegistration from "../components/WorkerRegistration";
import WorkerList from "../components/WorkerList";

export default function Workers() {
  const { user } = useContext(AuthContext);
  const [key, setKey] = useState("find");

  return (
    <Container className="mt-4">
      <Tabs activeKey={key} onSelect={(k) => setKey(k)} className="mb-4">
        <Tab eventKey="find" title="Find Workers">
          <WorkerList />
        </Tab>
        {user && (
          <Tab eventKey="register" title="Register as Worker">
            <WorkerRegistration />
          </Tab>
        )}
      </Tabs>
    </Container>
  );
}
